import { render, staticRenderFns } from "./OperatingRevenue.vue?vue&type=template&id=0934668e&scoped=true"
import script from "./OperatingRevenue.vue?vue&type=script&lang=js"
export * from "./OperatingRevenue.vue?vue&type=script&lang=js"
import style0 from "./OperatingRevenue.vue?vue&type=style&index=0&id=0934668e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0934668e",
  null
  
)

export default component.exports